import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Icon from '@mdi/react';
import { mdiPlusBox } from '@mdi/js';

const MemoTypeModal = (props) => {
  const { isOpen, toggleFunction, t, onTypeSelectionHandler } = props;

  return (
    <Modal isOpen={isOpen} toggle={toggleFunction} className="memo-type-modal">
      <ModalHeader toggle={toggleFunction} className="memo-type-modal-header">
        <span className="memo-type-modal-title">
          {t('communication.create-new-publication')}
        </span>
      </ModalHeader>
      <ModalBody>
        <div className="container">
          <div className="row">
            <div className="col-auto">
              <img
                src="https://appminime.com.br/smartapi/files/4ca74904c00799051b6ec64e830f01b6ffe31a1eaa24e828be"
                alt={t('communication.type-post')}
                title={t('communication.type-post')}
              />
            </div>
            <div className="col">
              <p className="memo-type-title">{t('communication.type-post')}</p>
              <p>{t('communication.type-post-description')}</p>
            </div>
            <div className="col-1 memo-type-option">
              <Icon
                path={mdiPlusBox}
                size={1}
                onClick={() => onTypeSelectionHandler('POST')}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-auto">
              <img
                src="https://appminime.com.br/smartapi/files/83f860a1ce982deddb7ef473a57c9bc0c694866167af10c478"
                alt={t('communication.type-survey')}
                title={t('communication.type-survey')}
              />
            </div>
            <div className="col">
              <p className="memo-type-title">
                {t('communication.type-survey')}
              </p>
              <p>{t('communication.type-survey-description')}</p>
            </div>
            <div className="col-1 memo-type-option">
              <Icon
                path={mdiPlusBox}
                size={1}
                onClick={() => onTypeSelectionHandler('SURV')}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-auto">
              <img
                src="https://appminime.com.br/smartapi/files/1d5c4b3a539fd2a24f6556c5bdf91a1ea0c1c2ddc3ae54f9f2"
                alt={t('communication.type-authorizations')}
                title={t('communication.type-authorizations')}
              />
            </div>
            <div className="col">
              <p className="memo-type-title">
                {t('communication.type-authorizations')}
              </p>
              <p>{t('communication.type-authorization-description')}</p>
            </div>
            <div className="col-auto memo-type-option">
              <Icon
                path={mdiPlusBox}
                size={1}
                onClick={() => onTypeSelectionHandler('AUTH')}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-auto">
              <img
                src="https://appminime.com.br/smartapi/files/f5f6d0fc80ae39bfae20ec6f1ea2e90da0e8174a5a1cce3766"
                alt={t('communication.inbox-title-activity')}
                title={t('communication.inbox-title-activity')}
              />
            </div>
            <div className="col">
              <p className="memo-type-title">
                {t('communication.inbox-title-activity')}
              </p>
              <p>{t('communication.type-activity-description')}</p>
            </div>
            <div className="col-1 memo-type-option">
              <Icon
                path={mdiPlusBox}
                size={1}
                onClick={() => onTypeSelectionHandler('ACTI')}
              />
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

MemoTypeModal.propTypes = {
  t: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleFunction: PropTypes.func.isRequired,
  onTypeSelectionHandler: PropTypes.func.isRequired,
};

export default withTranslation('common')(MemoTypeModal);
